import * as React from 'react'
import {ReactElement, ReactNode} from 'react'
import { SortDirection } from '@mui/material/TableCell';
import {NoWrapTableSortLabel} from './Table'
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';

export interface SortableTableHeaderCell {
    id: string
    label: string | ReactElement
    sortable?: boolean
    direction?: SortDirection
    noWrap?: boolean
    align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
    width?: string | number
}

interface SortableTableHeadProps {
    onSortOrderChange?: (sortId: string, event: React.MouseEvent<unknown>) => void
    headers?: SortableTableHeaderCell[]
    noWrap?: boolean
}

const SortableTableHeader: React.FC<SortableTableHeadProps> = props => {
    const {headers, onSortOrderChange} = props
    if (!headers) {
        return null
    }

    const handleClickHeader: (sortId: string) => (event: React.MouseEvent<unknown>) => void =
        (sortId: string) => (event: React.MouseEvent<unknown>) => {
            if (onSortOrderChange) {
                onSortOrderChange(sortId, event)
            }
        }

    const renderSortLabel = (cell: SortableTableHeaderCell): ReactNode => {
        const labelProps = {
            active: !(!cell.direction),
            hideSortIcon: !cell.sortable,
            disabled: !cell.sortable,
            direction: (cell.direction !== false) ? cell.direction : undefined,
            onClick: handleClickHeader(cell.id),
        }

        return (
            <TableCell key={cell.id} align={cell.align || 'center'} width={cell.width}>{
                ((props.noWrap || false) || (cell.noWrap || false))
                    ? <NoWrapTableSortLabel {...labelProps}>{cell.label}</NoWrapTableSortLabel>
                    : <TableSortLabel {...labelProps}>{cell.label}</TableSortLabel>
            }</TableCell>
        )
    }

    return (
        <TableHead>
            <TableRow>{headers.map(renderSortLabel)}</TableRow>
        </TableHead>
    )
}

SortableTableHeader.displayName = 'SortableTableHeader'
export default SortableTableHeader
